const spend = ({primary, secondary}) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198.8 155.4" width="190"
    >
        <g id="Home_page">
	<g>
		<path stroke={secondary} fill="none"  strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10" d="M108.1,90.3l-30.4,12.9c-12,4.4-12.9,37-12.9,48.1l0.1,3.1 M197.8,154.4l0.1-3.1c0-11.1-0.9-43.7-12.9-48.1
			l-30.4-12.9c-4.3-2.1-7.5-5.3-8.7-8.2c4.1-4.4,7.4-10.2,8.7-15.3l1.9-1.1c2.5-6.9,3.3-13.1,3-18.7l-1.4-1.1
			c0.4-5.1,0.2-14.4-2.2-18.9c-4.1-7.6-14.6-12.9-22.9-13h-3.2c-8.3,0.1-18.8,5.4-22.9,13c-2.5,4.5-2.6,13.8-2.2,18.9l-1.4,1.1
			c-0.3,5.7,0.5,11.8,3,18.7l1.9,1.1c1.3,5.1,4.6,10.8,8.7,15.3c-1.2,2.9-4.4,6.1-8.7,8.2"/>
		<path stroke={primary} fill="none" strokeWidth="2" strokeLinecap="round" strokeMiterlimit="10" d="M98.5,86.9c-5.4-9.3-14.3-11.1-26.1-14.2 M61.8,60.7c0,0,1.7,9.4,2.2,9.5c2.9,0.9,5.7,1.7,8.4,2.4 M1,109.1
			c2.3-34.1,16.9-30.7,41.9-39c0.5-0.1,1-9.5,1-9.5 M29.5,32c0.6,10.4,9.6,31.4,23.6,31.4c13.9,0,22.1-17.1,22.7-27.3
			c0.1-2.7,0,0,0.5-8.2 M27.5,33.7c0,0,17-18.1,21.8-20.4c7.6,13.8,24,23.7,25.8,25.3 M63.2,66.5c12,2.5,12.4-6.7,24.1-3.9
			c0,0-6.5-5.7-4.4-19.6c3-10.6,1.4-25.9-10.4-31.6l-5.7,2.8c0,0-0.5-8-4.6-11.5C36.7-6,19.9,20.5,23.4,45.9C25.2,60.5,43,67,43,67"
			/>
	</g>
</g>
    </svg>
)

export default spend;